import "/__w/1/s/BotFramework-WebChat/packages/component/src/SendBox/AttachmentBar/Preview/ImagePreview.module_built.css";
const classes = {"send-box-attachment-bar-item-image-preview":"wSCtrvW_send-box-attachment-bar-item-image-preview"}
export default classes

const _send_box_attachment_bar_item_image_preview0 = classes["send-box-attachment-bar-item-image-preview"]
export { _send_box_attachment_bar_item_image_preview0 as "send-box-attachment-bar-item-image-preview" }
